/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { Alert } from 'react-bootstrap';
import * as S from './styles';

export interface IBodyTitleProps {
  title?: string;
  subTitle?: string;
  alertText?: string;
}
export const BodyTitle = (props: IBodyTitleProps) => {
  const { title, subTitle, alertText } = props;
  return (
    <>
      <S.heading>{title}</S.heading>
      <S.subheading>{subTitle}</S.subheading>
      {alertText && <Alert variant="info">{alertText}</Alert>}
    </>
  );
};

BodyTitle.defaultProps = {
  title: 'You are almost there!',
  subTitle: 'To complete a policy we need a little bit information about you',
};
